<template>
  <div class="medal">
    <div class="medal-img">
      <img src="https://imgcdn.chuxingyouhui.com/blackunique/upload/e3a7e40d413c5d1fc4f3eda021f8835d.png">
    </div>
    <div class="title top">{{ resultInfo.medalAmount }}个骑士勋章</div>
    <div class="title">每<span>10000</span>骑士勋章</div>
    <div class="title bottom">可兑换1元现金</div>
  </div>
</template>
<script>
export default {
  name: 'Medal',
  props: {
    resultInfo: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../scale.scss';
.medal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 426px * $scale;
  width: 630px * $scale;
  text-align: center;
  margin-bottom: 30px * $scale;
  .medal-img {
    padding: 40px * $scale 178px * $scale 0 144px * $scale;
    img {
      width: 308px * $scale;
      height: 227px * $scale;
      vertical-align: bottom;
      object-fit: cover;
    }
  }
  .title {
    font-size: 28px * $scale;
    font-weight: 500;
    color: #333;
    line-height: 44px * $scale;
    span {
      color: #FF0900;
    }
    &.top {
      margin-top: 41px * $scale;
    }
  }
}
</style>
